const settingWhatsapp = [
    {
        id: "transaksi-reg",
        data: {
            name: "setting-wa",
            data: [
                {
                    id: "nota-transaksi-reg",
                    value: "1",
                    title: `<label class='f-regular f-14 f-c-black m-0' for='nota-transaksi-reg'>Nota transaksi reguler & deposit</label>`,
                    checked: false,
                    titleBold: false,
                    label: "Nota transaksi reguler & deposit"
                },
            ],
        },
    },
    // {
    //     id: "transaksi-snap",
    //     data: {
    //         name: "setting-wa",
    //         data: [
    //             {
    //                 id: "nota-transaksi-snap",
    //                 value: "1",
    //                 title: `<label class='f-regular f-14 f-c-black m-0' for='nota-transaksi-snap'>Nota transaksi Snapclean</label>`,
    //                 checked: false,
    //                 titleBold: false,
    //                 label: "Nota transaksi Snapclean"
    //             },
    //         ],
    //     },
    // },
    {
        id: "top-up-deposit",
        data: {
            name: "setting-wa",
            data: [
                {
                    id: "top-up-deposit",
                    value: "1",
                    title: `<label class='f-regular f-14 f-c-black m-0' for='top-up-deposit'>Nota Topup Deposit</label>`,
                    checked: false,
                    titleBold: false,
                    label: "Nota Topup Deposit"
                },
            ],
        },
    },
    {
        id: "top-up-epayment",
        data: {
            name: "setting-wa",
            data: [
                {
                    id: "top-up-epayment",
                    value: "1",
                    title: `<label class='f-regular f-14 f-c-black m-0' for='top-up-epayment'>Nota Topup E-Payment</label>`,
                    checked: false,
                    titleBold: false,
                    label: "Nota Topup E-Payment"
                },
            ],
        },
    },
    {
        id: "notif-selesai",
        data: {
            name: "setting-wa",
            data: [
                {
                    id: "notif-selesai",
                    value: "1",
                    title: `<label class='f-regular f-14 f-c-black m-0' for='notif-selesai'>Pengingat transaksi selesai</label>`,
                    checked: false,
                    titleBold: false,
                    label: "Pengingat transaksi selesai"
                },
            ],
        },
    },
    {
        id: "bukti-ambil",
        data: {
            name: "setting-wa",
            data: [
                {
                    id: "bukti-ambil",
                    value: "1",
                    title: `<label class='f-regular f-14 f-c-black m-0' for='bukti-ambil'>Nota Bukti Saat Pengambilan</label>`,
                    checked: false,
                    titleBold: false,
                    label: "Bukti saat Pengambilan"
                },
            ],
        },
    },
	{
        id: "pelunasan",
        data: {
            name: "setting-wa",
            data: [
                {
                    id: "pelunasan",
                    value: "1",
                    title: `<label class='f-regular f-14 f-c-black m-0' for='pelunasan'>Nota Bukti Saat Pelunasan</label>`,
                    checked: false,
                    titleBold: false,
                    label: "Bukti saat pelunasan"
                },
            ],
        },
    },

    {
        id: "notif-pengambilan",
        data: {
            name: "setting-wa",
            data: [
                {
                    id: "notif-pengambilan",
                    value: "1",
                    title: `<label class='f-regular f-14 f-c-black m-0' for='notif-pengambilan'>Pengingat pengambilan</label>`,
                    checked: false,
                    titleBold: false,
                    label: "Pengingat pengambilan"
                },
            ],
        },
    },
];

export default settingWhatsapp;
